import React from 'react';
import { Instagram, Youtube, Mail, MessageSquare } from 'lucide-react';
const ContactPage = () => {
  return <div className="bg-cream py-12" data-id="element-346">
      {/* Hero Section */}
      <section className="bg-beige py-16 mb-12" data-id="element-347">
        <div className="container mx-auto px-4 text-center" data-id="element-348">
          <h1 className="text-3xl md:text-4xl font-bold text-brown mb-4" data-id="element-349">
            Contact Us
          </h1>
          <p className="text-gray-700 max-w-2xl mx-auto" data-id="element-350">
            We'd love to hear from you! Get in touch with any questions,
            feedback, or inquiries.
          </p>
        </div>
      </section>
      <div className="container mx-auto px-4" data-id="element-351">
        <div className="flex flex-col md:flex-row gap-12" data-id="element-352">
          {/* Contact Form */}
          <div className="md:w-2/3" data-id="element-353">
            <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-354">
              <h2 className="text-2xl font-bold text-brown mb-6" data-id="element-355">
                Send Us a Message
              </h2>
              <iframe src="https://tally.so/embed/3yOVlW?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1&formEventsForwarding=1" width="100%" height="500" frameBorder="0" marginHeight={0} marginWidth={0} title="Contact Jemi Baby Care" data-id="element-356"></iframe>
            </div>
          </div>
          {/* Contact Information */}
          <div className="md:w-1/3" data-id="element-357">
            <div className="bg-white p-8 rounded-lg shadow-md mb-8" data-id="element-358">
              <h2 className="text-2xl font-bold text-brown mb-6" data-id="element-359">
                Contact Information
              </h2>
              <div className="space-y-4" data-id="element-360">
                <div className="flex items-start" data-id="element-361">
                  <Mail className="text-brown mr-3 mt-1" size={20} data-id="element-362" />
                  <div data-id="element-363">
                    <h3 className="font-bold text-gray-700" data-id="element-364">Email</h3>
                    <p className="text-gray-600" data-id="element-365">hello@jemibabycare.store</p>
                    <p className="text-gray-600" data-id="element-366">doctor@jemibabycare.store</p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-367">
                  <MessageSquare className="text-brown mr-3 mt-1" size={20} data-id="element-368" />
                  <div data-id="element-369">
                    <h3 className="font-bold text-gray-700" data-id="element-370">WhatsApp</h3>
                    <a href="https://wa.me/2348065406312" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-brown" data-id="element-371">
                      +234 806 540 6312
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-372">
              <h2 className="text-2xl font-bold text-brown mb-6" data-id="element-373">Follow Us</h2>
              <div className="space-y-4" data-id="element-374">
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="flex items-center text-gray-700 hover:text-brown transition-colors duration-300" data-id="element-375">
                  <Instagram className="mr-3" size={20} data-id="element-376" />
                  <span data-id="element-377">@jemibabycare</span>
                </a>
                <a href="https://youtube.com/@jemibabycare" target="_blank" rel="noopener noreferrer" className="flex items-center text-gray-700 hover:text-brown transition-colors duration-300" data-id="element-378">
                  <Youtube className="mr-3" size={20} data-id="element-379" />
                  <span data-id="element-380">Jemi Baby Care</span>
                </a>
                <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" className="flex items-center text-gray-700 hover:text-brown transition-colors duration-300" data-id="element-381">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-3" data-id="element-382">
                    <path d="M21 8V16C21 18.7614 18.7614 21 16 21H8C5.23858 21 3 18.7614 3 16V8C3 5.23858 5.23858 3 8 3H16C18.7614 3 21 5.23858 21 8Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-383" />
                    <path d="M10 12C8.34315 12 7 13.3431 7 15C7 16.6569 8.34315 18 10 18C11.6569 18 13 16.6569 13 15V9C13.3333 10 14.6 12 17 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-384" />
                  </svg>
                  <span data-id="element-385">@jemibabycare</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default ContactPage;